import transform from "lodash/transform";

import { ConnectionTypes } from "./integrations";

export const WHITELISTED_NB_USERS_FOR_PARTNER_CONSENT = [
  "benedict@northbeam.io",
  "dan@northbeam.io",
  "stas@northbeam.io",
  "luan@northbeam.io",
  "zach.sherrod@northbeam.io",
  "valerie@northbeam.io",
];

export const FEATURE_FLAG_FOR_PARTNER_CONSENT_MAPPING = {
  APPLOVIN: "enableAppLovinPartnerConsent",
  META: "enableMetricsAggregationForMetaPartnership",
  MNTN: undefined,
  PINTEREST: undefined,
  SNAPCHAT: undefined,
  TIKTOK: "enableTiktokPartnerConsent",
  VIBE: undefined,
} as const;

// TODO: remove this and start using the `PARTNERS_INFO_MAPPING` below
export const DISPLAY_NAME_FOR_PARTNER_MAPPING = {
  APPLOVIN: "AppLovin",
  META: "Meta",
  MNTN: "MNTN",
  PINTEREST: "Pinterest",
  SNAPCHAT: "Snapchat",
  TIKTOK: "TikTok",
  VIBE: "Vibe",
} as const;

export const PARTNERS_INFO_MAPPING = {
  APPLOVIN: {
    displayName: "AppLovin",
    supportedPermissionsFeatureFlagMapping: {
      data_exports: "displayAppLovinConsentForApex",
      data_impression_ingestion: "displayAppLovinConsentForCve",
    },
    connectionType: ConnectionTypes.INTEGRATION_APPLOVIN,
  },
  META: {
    displayName: "Meta",
    supportedPermissionsFeatureFlagMapping: {
      data_exports: "displayMetaConsentForApex",
      data_impression_ingestion: "displayMetaConsentForCve",
    },
    connectionType: ConnectionTypes.INTEGRATION_FACEBOOK_ADS,
  },
  MNTN: {
    displayName: "MNTN",
    supportedPermissionsFeatureFlagMapping: {
      data_exports: "displayMNTNConsentForApex",
      data_impression_ingestion: "displayMNTNConsentForCve",
    },
    connectionType: ConnectionTypes.INTEGRATION_MNTN,
  },
  PINTEREST: {
    displayName: "Pinterest",
    supportedPermissionsFeatureFlagMapping: {
      data_exports: "displayPinterestConsentForApex",
      data_impression_ingestion: "displayPinterestConsentForCve",
    },
    connectionType: ConnectionTypes.INTEGRATION_PINTEREST,
  },
  SNAPCHAT: {
    displayName: "Snapchat",
    supportedPermissionsFeatureFlagMapping: {
      data_exports: "displaySnapchatConsentForApex",
      data_impression_ingestion: "displaySnapchatConsentForCve",
    },
    connectionType: ConnectionTypes.INTEGRATION_SNAPCHAT,
  },
  TIKTOK: {
    displayName: "TikTok",
    supportedPermissionsFeatureFlagMapping: {
      data_exports: false,
      data_impression_ingestion: "displayTikTokConsentForCve",
    },
    connectionType: ConnectionTypes.INTEGRATION_TIKTOK,
  },
  VIBE: {
    displayName: "Vibe",
    supportedPermissionsFeatureFlagMapping: {
      data_exports: "displayVibeConsentForApex",
      data_impression_ingestion: "displayVibeConsentForCdv",
    },
    connectionType: ConnectionTypes.INTEGRATION_VIBE,
  },
} as const;

type SupportedPartners = keyof typeof PARTNERS_INFO_MAPPING;

export const PARTNERS_SUPPORTING_ENHANCED_CLICKS_AND_VIEWS = transform<
  typeof PARTNERS_INFO_MAPPING,
  SupportedPartners[]
>(
  PARTNERS_INFO_MAPPING,
  (partnersSupportingCve, partnerInfo, partnerName) => {
    partnerInfo.supportedPermissionsFeatureFlagMapping
      .data_impression_ingestion && partnersSupportingCve.push(partnerName);
  },
  [],
);

export const PARTNERS_SUPPORTING_APEX = transform<
  typeof PARTNERS_INFO_MAPPING,
  SupportedPartners[]
>(
  PARTNERS_INFO_MAPPING,
  (partnersSupportingApex, partnerInfo, partnerName) => {
    partnerInfo.supportedPermissionsFeatureFlagMapping.data_exports &&
      partnersSupportingApex.push(partnerName);
  },
  [],
);

export const PERMISSIONS_INFO_MAPPING = {
  data_exports: {
    product: "Apex",
    annotationFeatureFlag: "enableApexChartAnnotation",
  },
  data_impression_ingestion: {
    product: "Clicks + Deterministic Views Model",
    annotationFeatureFlag: "enableCVEnhancedChartAnnotation",
  },
};
